export enum RadioButtonStates {
  on = 'on',
  off = 'off'
}

export enum ManagedPolicy {
  scan = 'scan',
  allow = 'allow',
  block = 'block'
}

export enum ExemptSenders {
  block = '0',
  allow = '1',
  partiallyAllow = '2'
}

export enum OutboundQuarantineInterval {
  NEVER = 'never',
  IMMEDIATELY = 'immediately',
  CUSTOM = 'custom'
}

export interface CustomSchedule {
  mon: Record<number, true>
  tue: Record<number, true>
  wed: Record<number, true>
  thu: Record<number, true>
  fri: Record<number, true>
  sat: Record<number, true>
  sun: Record<number, true>
}

// Defining as a function to avoid unintentional overwrites of the default
// TODO: select and start using an immutable data library
export const DEFAULT_CUSTOM_SCHEDULE_VALUE: () => CustomSchedule = () => ({
  mon: {},
  tue: {},
  wed: {},
  thu: {},
  fri: {},
  sat: {},
  sun: {}
})

export enum SettingType {
  DB = 'db',
  QNS = 'qns'
}

export type UI_UNSET = ''

export const UI_UNSET_VALUE: UI_UNSET = ''

export type InboundQnsInterval = 'custom' | 'never'

export const DEFAULT_TIMEZONE = 'America/Los_Angeles'
